import { render } from "./catalogue.vue?vue&type=template&id=75945c4c&scoped=true&ts=true"
import script from "./catalogue.vue?vue&type=script&lang=ts"
export * from "./catalogue.vue?vue&type=script&lang=ts"

import "./catalogue.vue?vue&type=style&index=0&id=75945c4c&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75945c4c"]])

export default __exports__